"use client"

import useSWR, { mutate } from 'swr'
import storage from '@utils/localStorage'
import checkLogin from '@utils/checkLogin'
import { get } from '@api/apiFetcher'

const KEY = 'msg-unread'
const VISIBLE_MS = 30000
const HIDDEN_MS = 120000

const fetcher = ([, token]) => get({ path: '/api/messages/state', auth: token }).then(r => {
    if (!r?.success) throw new Error('state')
    return r.unread
})

// Nieprzeczytane (rozmowy i od Samochody.pl): odświeżane co 30 s przy widocznej karcie, co 2 min w tle,
// od razu po powrocie do karty. { total, r, s }; gość — zera.
export function useUnread () {
    const { data: user } = useSWR('user', storage)
    const token = checkLogin(user) ? user.token : null
    const { data } = useSWR(token ? [KEY, token] : null, fetcher, {
        refreshInterval: () => (typeof document !== 'undefined' && document.hidden ? HIDDEN_MS : VISIBLE_MS),
        refreshWhenHidden: true,
        revalidateOnFocus: true,
        dedupingInterval: 4000,
        shouldRetryOnError: false,
    })
    return data || { total: 0, r: 0, s: 0 }
}

export const refreshUnread = () => mutate(key => Array.isArray(key) && key[0] === KEY)

export const unreadLabel = (n) => (n ? `Wiadomości, nieprzeczytane: ${n}` : 'Wiadomości')
export const badgeText = (n) => (n > 9 ? '9+' : String(n))
